<template>
  <svg
    width="39"
    height="35"
    viewBox="0 0 39 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_5575_1199)">
      <mask
        id="mask0_5575_1199"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="0"
        width="32"
        height="32">
        <rect x="2" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5575_1199)">
        <path
          d="M9.99935 26.6654C8.53268 26.6654 7.27713 26.1431 6.23268 25.0987C5.18824 24.0543 4.66602 22.7987 4.66602 21.332V10.6654C4.66602 9.1987 5.18824 7.94314 6.23268 6.8987C7.27713 5.85425 8.53268 5.33203 9.99935 5.33203H25.9993C27.466 5.33203 28.7216 5.85425 29.766 6.8987C30.8105 7.94314 31.3327 9.1987 31.3327 10.6654V21.332C31.3327 22.7987 30.8105 24.0543 29.766 25.0987C28.7216 26.1431 27.466 26.6654 25.9993 26.6654H9.99935ZM9.99935 10.6654H25.9993C26.4882 10.6654 26.9549 10.7209 27.3993 10.832C27.8438 10.9431 28.266 11.1209 28.666 11.3654V10.6654C28.666 9.93203 28.4049 9.30425 27.8827 8.78203C27.3605 8.25981 26.7327 7.9987 25.9993 7.9987H9.99935C9.26602 7.9987 8.63824 8.25981 8.11602 8.78203C7.59379 9.30425 7.33268 9.93203 7.33268 10.6654V11.3654C7.73268 11.1209 8.1549 10.9431 8.59935 10.832C9.04379 10.7209 9.51046 10.6654 9.99935 10.6654ZM7.53268 14.9987L22.366 18.5987C22.566 18.6431 22.766 18.6431 22.966 18.5987C23.166 18.5543 23.3549 18.4654 23.5327 18.332L28.166 14.4654C27.9216 14.132 27.6105 13.8598 27.2327 13.6487C26.8549 13.4376 26.4438 13.332 25.9993 13.332H9.99935C9.42157 13.332 8.91602 13.482 8.48268 13.782C8.04935 14.082 7.73268 14.4876 7.53268 14.9987Z"
          fill="#B5B5B5" />
      </g>
    </g>
    <g clip-path="url(#clip0_5575_1199)">
      <path
        d="M31 32C35.4183 32 39 28.4183 39 24C39 19.5817 35.4183 16 31 16C26.5817 16 23 19.5817 23 24C23 28.4183 26.5817 32 31 32Z"
        fill="white" />
      <path
        d="M33.241 22.7311V25.6318L30.8984 26.9665V29.4628L35.8408 26.6009V21.2266L33.241 22.7311Z"
        fill="black" />
      <path
        d="M28.7195 25.6765V22.8178L26.1602 21.3359V26.7216L30.9019 29.4718V26.9594L28.7195 25.6765Z"
        fill="black" />
      <path
        d="M33.8835 20.0173L28.7147 22.8258L26.1602 21.3375L31.3339 18.5273L33.8835 20.0173Z"
        fill="black" />
    </g>
    <defs>
      <filter
        id="filter0_d_5575_1199"
        x="0.666016"
        y="5.33203"
        width="34.666"
        height="29.332"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5575_1199" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5575_1199"
          result="shape" />
      </filter>
      <clipPath id="clip0_5575_1199">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(23 16)" />
      </clipPath>
    </defs>
  </svg>
</template>
